module.exports = __webpack_public_path__ + "img/vx3.06996f0e.png";